import { Interop_reactApi } from "../fable_modules/Feliz.2.4.0/./Interop.fs.js";
import { cons, ofArray } from "../fable_modules/fable-library.4.1.4/List.js";
import { createElement } from "react";
import React from "react";
import { useFeliz_React__React_useState_Static_1505 } from "../fable_modules/Feliz.2.4.0/React.fs.js";
import { equals, createObj } from "../fable_modules/fable-library.4.1.4/Util.js";
import { String_isntWhitespace } from "../Core/Common.fs.js";

export function class$0027(className, ctor, elements) {
    return ctor(ofArray([["className", className], ["children", Interop_reactApi.Children.toArray(Array.from(elements))]]));
}

export function classP$0027(className, ctor, elements) {
    return ctor(cons(["className", className], elements));
}

export function classTxt$0027(className, ctor, txt) {
    return ctor(ofArray([["className", className], ["children", txt]]));
}

export function checkbox(id, text, isChecked, onClick) {
    const children = ofArray([createElement("input", {
        id: id,
        type: "checkbox",
        checked: isChecked,
        readOnly: true,
        onClick: onClick,
    }), createElement("label", {
        htmlFor: id,
        children: text,
    })]);
    return createElement("section", {
        children: Interop_reactApi.Children.toArray(Array.from(children)),
    });
}

export function TextEntryForm(textEntryFormInputProps) {
    let elems, value;
    const onFinished = textEntryFormInputProps.onFinished;
    const placeholder = textEntryFormInputProps.placeholder;
    const patternInput = useFeliz_React__React_useState_Static_1505("");
    const txt = patternInput[0];
    return createElement("form", createObj(ofArray([(elems = [createElement("input", createObj(ofArray([(value = txt, ["ref", (e) => {
        if (!(e == null) && !equals(e.value, value)) {
            e.value = value;
        }
    }]), ["type", "text"], ["placeholder", placeholder], ["onChange", (ev) => {
        patternInput[1](ev.target.value);
    }]]))), createElement("button", {
        type: "submit",
        children: "OK",
    })], ["children", Interop_reactApi.Children.toArray(Array.from(elems))]), ["onSubmit", (e_1) => {
        e_1.preventDefault();
        if (String_isntWhitespace(txt)) {
            onFinished(txt);
        }
    }]])));
}

//# sourceMappingURL=CommonUI.fs.js.map
